import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.854 4.333h-2v-.666a2 2 0 0 0-2-2H7.521a2 2 0 0 0-2 2v.666h-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9.333a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2m-6-.666A.667.667 0 0 1 7.521 3h1.333a.667.667 0 0 1 .667.667v.666H6.854zm6.667 8.666a.667.667 0 0 1-.667.667H3.521a.667.667 0 0 1-.667-.667V8.667a14.5 14.5 0 0 0 5.334 1.02 14.5 14.5 0 0 0 5.333-1.02zm0-5.126a13.26 13.26 0 0 1-10.667 0v-.874a.667.667 0 0 1 .667-.666h9.333a.667.667 0 0 1 .667.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })